module.exports = __webpack_public_path__ + "img/icon_logo232.a248eabb.png";